module.exports = __webpack_public_path__ + "static/apca-97d073e3da7482be951882e6b0802c9f.png";